import { StatusTone } from '../_core/_ui/status-chip.types';
import { AgeGroupReportCardWrite, ReportCardStatusFilter, SendSkipReason } from './report-card-access.types';

export const REPORT_CARD_STATUS_TONES: Record<ReportCardAccessStatus, StatusTone> = {
  NO_DATA: 'neutral',
  NOT_RELEASED: 'pending',
  AVAILABLE: 'success',
  REVOKED: 'danger',
  AGE_GROUP_REVOKED: 'danger',
};

// In display order; each option matches the statuses it lists.
export const REPORT_CARD_STATUS_FILTERS: { filter: ReportCardStatusFilter; statuses: ReportCardAccessStatus[] }[] = [
  { filter: 'AVAILABLE', statuses: ['AVAILABLE'] },
  { filter: 'NOT_RELEASED', statuses: ['NOT_RELEASED'] },
  { filter: 'REVOKED', statuses: ['REVOKED', 'AGE_GROUP_REVOKED'] },
  { filter: 'NO_DATA', statuses: ['NO_DATA'] },
];

// The availability panel's status counts, in display order, each read from its counts field.
export const REPORT_CARD_STATUS_COUNTS: { status: ReportCardAccessStatus; field: keyof IReportCardAvailabilityCounts }[] = [
  { status: 'AVAILABLE', field: 'available' },
  { status: 'NOT_RELEASED', field: 'notReleased' },
  { status: 'REVOKED', field: 'revoked' },
  { status: 'AGE_GROUP_REVOKED', field: 'ageGroupRevoked' },
  { status: 'NO_DATA', field: 'noData' },
];

export const SEND_SKIP_REASON_ORDER: SendSkipReason[] = [
  'notConcluded', 'alreadyReleased', 'noData', 'revoked', 'ageGroupRevoked', 'notReleased',
];

export const AGE_GROUP_REPORT_CARD_WRITES: AgeGroupReportCardWrite[] = ['ACCESS', 'SETTING', 'SEND'];
